import { uniqBy } from 'lodash';
import { User } from 'msal';
import { TYPES } from 'action-types/user';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { callApiGet, callApiGetForUam, callApiV2Get } from 'utilities/apiCaller';
import API from 'constants/api';
import { generateErrors } from 'utilities/util';
import { TransportMode } from 'constants/modes';

export const setUser = (user: User) => ({type: TYPES.SET_USER, user});

export const getUAMBusinessFunctions = () => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({type: TYPES.GET_UAM_BUSINESS_FUNCTIONS.PENDING});
        const promises = [
            dispatch(getFactBusinessFunctions())
        ]; 
        try {
            const res = await Promise.all(promises.map(p => p.catch(_ => 'No permissions')));
            const flatArr:any = res.reduce((acc:any, val:any) => acc.concat(val), [])
            const flatArray = uniqBy(flatArr, 'name' || 'Name');
            sessionStorage.setItem('roles', JSON.stringify(flatArray));
            dispatch({type: TYPES.GET_UAM_BUSINESS_FUNCTIONS.FULFILLED, roles: flatArray});
        } catch(e) {
            const error = generateErrors(e);
            dispatch({type: TYPES.GET_UAM_BUSINESS_FUNCTIONS.REJECTED, error});
        }
    }
};

export const getUserUamPermission = () => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.GET_USER_UAM_PERMISSION.PENDING });
        try {
            const url = API.UAM.GetPermission.split('/finance')[0]
            const res = await callApiGetForUam(`${url}/user-permissions`, {},{ headers: {
                TransportMode:
                    TransportMode.Ocean,
            }, });
            dispatch({ type: TYPES.GET_USER_UAM_PERMISSION.FULFILLED, userPermissions: res.data });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({ type: TYPES.GET_USER_UAM_PERMISSION.REJECTED, errors });
        }
    }
};


const getFactBusinessFunctions = () => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({type: TYPES.GET_CT_UAM_BUSINESS_FUNCTIONS.PENDING});
        try {
            const res = await callApiV2Get(`${API.UAM.GetRolesUamV4}`);
            dispatch({type: TYPES.GET_CT_UAM_BUSINESS_FUNCTIONS.FULFILLED, roles: res.data});
            return res.data
        }
        catch (e) {
            try {
                const res = await callApiGet(`${API.UAM.GetRoles}`);
                dispatch({type: TYPES.GET_CT_UAM_BUSINESS_FUNCTIONS.FULFILLED, roles: res.data});
                return res.data
            }
            catch (e) {
                dispatch({type: TYPES.GET_CT_UAM_BUSINESS_FUNCTIONS.REJECTED});
                throw e;
            }
        }   
    }
};
